export default __webpack_public_path__ + "static/media/phone-call.4e2c7f70.svg";